'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _underscore = require('../../utils/underscore');

var _Functions = require('../../core/Functions');

var _UIAbstractDropdown = require('./UIAbstractDropdown');

var _UIAbstractDropdown2 = _interopRequireDefault(_UIAbstractDropdown);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Keeps track of the effective placement and sets arrowColor accordingly
exports.default = _react2.default.createClass({
  displayName: 'UIAbstractDropdownWithSearchbox',

  propTypes: _extends({}, (0, _underscore.omit)(_UIAbstractDropdown2.default.propTypes, 'arrowColor'), {
    hasSearchbox: _react.PropTypes.bool.isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    return _UIAbstractDropdown2.default.defaultProps;
  },
  getInitialState: function getInitialState() {
    return {
      placement: null
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // If the placement prop is reset, clear our internal override.
    if (nextProps.placement !== this.props.placement) {
      this.setState({
        placement: null
      });
    }
    if (nextProps.open && !this.props.open) {
      this.setState({
        placement: null
      });
    }
  },
  handleChangePlacement: function handleChangePlacement(evt) {
    var onChangePlacement = this.props.onChangePlacement;
    var newPlacement = evt.newPlacement;

    if (this.state.placement !== newPlacement) {
      this.setState({ placement: newPlacement });
    }
    (0, _Functions.callIfPossible)(onChangePlacement, evt);
  },
  reposition: function reposition() {
    if (this._popoverRef) {
      this._popoverRef.reposition();
    }
  },
  popoverRefCallback: function popoverRefCallback(ref) {
    this._popoverRef = ref;
  },
  getPlacement: function getPlacement(_ref) {
    var buttonUse = _ref.buttonUse,
        placement = _ref.placement;

    var defaultPlacement = buttonUse.match(/link|transparent/) ? 'bottom' : 'bottom right';
    return this.state.placement || placement || defaultPlacement;
  },
  getArrowColor: function getArrowColor(_ref2, _ref3) {
    var hasSearchbox = _ref2.hasSearchbox;
    var computedPlacement = _ref3.computedPlacement;

    return hasSearchbox && computedPlacement.indexOf('bottom') >= 0 ? _colors.KOALA : null;
  },
  getDropdownClassName: function getDropdownClassName(_ref4, _ref5) {
    var dropdownClassName = _ref4.dropdownClassName,
        hasSearchbox = _ref4.hasSearchbox;
    var computedPlacement = _ref5.computedPlacement;

    var arrowAtBottom = computedPlacement.indexOf('bottom') !== -1;
    var arrowAtTop = computedPlacement.indexOf('top') !== -1;
    return (0, _reactUtils.classNames)(dropdownClassName, {
      'p-y-0': hasSearchbox && arrowAtBottom,
      'p-top-0': hasSearchbox && arrowAtTop
    });
  },
  render: function render() {
    var _props = this.props,
        buttonUse = _props.buttonUse,
        dropdownClassName = _props.dropdownClassName,
        hasSearchbox = _props.hasSearchbox,
        placement = _props.placement,
        rest = _objectWithoutProperties(_props, ['buttonUse', 'dropdownClassName', 'hasSearchbox', 'placement']);

    var computedPlacement = this.getPlacement({ buttonUse: buttonUse, placement: placement });
    var computedArrowColor = this.getArrowColor({ hasSearchbox: hasSearchbox }, { computedPlacement: computedPlacement });
    var computedDropdownClassName = this.getDropdownClassName({ dropdownClassName: dropdownClassName, hasSearchbox: hasSearchbox }, { computedPlacement: computedPlacement });

    return _react2.default.createElement(_UIAbstractDropdown2.default, _extends({}, rest, {
      arrowColor: computedArrowColor,
      buttonUse: buttonUse,
      dropdownClassName: computedDropdownClassName,
      onChangePlacement: this.handleChangePlacement,
      placement: computedPlacement,
      ref: this.popoverRefCallback
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/dropdown/abstract/UIAbstractDropdownWithSearchbox.js
// module id = 299
// module chunks = 0